module.exports = __webpack_public_path__ + "img/WatchHeader.f9a341c8.jpg";